export const RIS_DEPARTMENT_MAPPER: { [department: string]: string } = {
  services: 'RSR',
  rek: 'RSR',
  ahb: 'AHB',
  ehsm: 'EHSM',
  g: 'G',
  hafl: 'HAFL',
  hkb: 'HKB',
  s: 'S',
  ti: 'TI',
  w: 'W',
} as const;
